import Alert, {
  AlertDescription,
  AlertTitle,
} from "@/lib/components/ui/alert/alert";
import Shield from "@/lib/components/ui/icons/shield";
import { cn } from "@/lib/utils";
import type { HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import { type Permission } from "@soulbyte/core";

const PermissionsAlert = Alert;
export default PermissionsAlert;

export const PermissionsAlertIcon = Shield;
export const PermissionsAlertTitle = AlertTitle;
export const PermissionsAlertDescription = AlertDescription;

export function PermissionsAlertDetails({
  className,
  permissions,
  ...props
}: HTMLAttributes<HTMLDivElement> & {
  permissions: Permission[];
}) {
  const { t } = useTranslation();

  if (permissions.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        "col-start-2 mt-2 grid justify-items-start gap-1 text-sm",
        className,
      )}
      {...props}
    >
      {t("permissions_required_permissions")}
      <ul className="list-inside list-disc">
        {permissions.map((permission) => (
          <li key={permission}>
            <code>{permission}</code>
          </li>
        ))}
      </ul>
    </div>
  );
}
